import { events } from './navigationLinksContainerReducerActions'

const initialState = {
  navigationLinksFetched: false,
  sidebarOpen: false,
  publicPortalUrl: 'https://www.allangray.co.za',
  navigationLinks: {},
  activeMenu: null
}

export default function navigationLinksReducer(state = initialState, action) {
  switch (action.type) {
    case events.fetched.navigationLinks:
      return {
        ...state,
        navigationLinks: action.payload,
        navigationLinksFetched: true
      }

    case events.sidebar.set.open:
      return {
        ...state,
        sidebarOpen: action.open
      }

    case events.header.mainMenu.dropdown.enter:
      return {
        ...state,
        activeMenu: action.menuName,
        navigationLinks: {
          ...state.navigationLinks,
          MainMenu: state.navigationLinks.MainMenu.map(item =>
            item.Name === action.menuName
              ? { ...item, open: true }
              : item
          )
        }
      }

    case events.header.mainMenu.dropdown.leave:
      return {
        ...state,
        activeMenu: '',
        navigationLinks: {
          ...state.navigationLinks,
          MainMenu: state.navigationLinks.MainMenu.map(item =>
            item.Name === action.menuName
              ? { ...item, open: false }
              : item
          )
        }
      }

    case events.header.mainMenu.dropdown.click:
      return {
        ...state,
        navigationLinks: {
          ...state.navigationLinks,
          MainMenu: state.navigationLinks.MainMenu.map(item =>
            item.Name === action.menuName
              ? { ...item, open: !item.open }
              : item
          )
        }
      }

    case events.sidebar.set.activeMenu:
      return {
        ...state,
        activeMenu: state.activeMenu === action.name ? null : action.name
      }

    default:
      return state
  }
}
